/* eslint-disable no-unused-vars */
import images from './images';

const awards = [
  {
    imgUrl: images.award02,
    title: 'Best Food Quality',
    subtitle:
      'Aire Cafe has spread its aroma in this industry over the past few years.',
  },
  {
    imgUrl: images.award01,
    title: 'Magical Atmosphere',
    subtitle:
      'An unforgettable Dining ,Lunch & Small party experience for you and your  friends',
  },
  {
    imgUrl: images.award05,
    title: '5 Star Services',
    subtitle:
      "We are friendly, available, attentive and quick to take care of customers' needs. ",
  },
];

const aireMenuData = {
  breakfast: {
    fullBrunch: [
      { name: 'Aloo Paratha with Curd & Pickle', price: 100 },
      { name: 'Puri with Sabzi', price: 100 },
      { name: 'Nature with Chole', price: 100 },
      { name: 'MorningCulinary', price: 499 },
      { name: 'Wake Up the Bed', price: 499 },
      { name: 'Morning Sunrise', price: 599 },
    ],
    healthyBites: [
      { name: 'Fresh Cut Fruits Platter', price: 200 },
      { name: 'Granola', price: 130 },
      { name: "Choco's with Hot Milk", price: 175 },
      { name: 'Bread Toast with Butter or Jam', price: 175 },
      { name: 'French Toast', price: 200 },
      { name: 'Club Sandwich (Veg or Non-Veg)', price: [225, 300] },
      { name: 'Baked Beans & Mushroom', price: 150 },
      { name: 'Scrambled Eggs with Grilled Tomato', price: 200 },
      { name: 'Egg to Orders', price: 150 },
      { name: 'Fresh Fruit Juice', price: 150 },
    ],
    heartyAndNaughty: [
      { name: 'Pan Cake', price: 250 },
      { name: 'Cheese Cake', price: 300 },
      { name: 'Muffins', price: 110 },
      { name: 'Pudding', price: 200 },
    ],
  },
  soups: [
    { name: 'International Mulligatawny Soup', price: 165 },
    { name: 'Tomato Shoraba Shooba', price: 166 },
    { name: 'Sweet Corn Soup', price: [175, 210] },
    { name: 'Hot & Sour Soup', price: [175, 210] },
    { name: 'Minced Chicken Soup', price: [175, 210] },
    { name: 'Veg Soup', price: [185, 235] },
    { name: 'Tom Ka Tai Soup', price: [185, 235] },
    { name: 'Cream of Tomato Soup', price: [210, 250] },
    { name: 'Cream of Mushroom Soup', price: [210, 250] },
    { name: 'Roasted Almond & Broccoli Soup', price: [210, 250] },
  ],
  starterVeg: {
    chinese: [
      { name: 'Crispy Chilly Baby Corn', price: 245 },
      { name: 'American Corn Salt & Pepper', price: 265 },
      { name: 'Spring Roll', price: 265 },
      { name: 'Salt & Pepper Mushroom', price: 265 },
      { name: 'Paneer Shashlik', price: 285 },
      { name: 'Tandoori Paneer', price: 285 },
      { name: 'BBQ Paneer', price: 300 },
      { name: 'Chilly Paneer', price: 300 },
    ],
    indian: [
      { name: 'Rabdi Aloo (6 Pcs)', price: 210 },
      { name: 'Hara Bhara Kebab (6 Pcs)', price: 275 },
      { name: 'Dahi Ke Kebab (6 Pcs)', price: 275 },
      { name: 'Chana Seekh Kebab (6 Pcs)', price: 285 },
    ],
    continental: [
      { name: 'Paneer Tikka (6 Pcs)', price: 285 },
      { name: 'Khumbos Angaara (8 Pcs)', price: 290 },
      { name: 'French Fries', price: 250 },
      { name: 'Cheeze Chilli Tost', price: 275 },
      { name: 'Veg Cheese Roll', price: 275 },
      { name: 'Cheese Garlic Bread', price: 275 },
      { name: 'Cheese Cherry Pineapple', price: 275 },
      { name: 'Aire Special Tandoori', price: 275 },
      { name: 'Nachos with Salsa', price: 285 },
      { name: 'Souté Vegetable', price: 300 },
    ],
    aireSignature: [
      { name: 'Dragon Roll', price: 285 },
      { name: 'Dynamite Paneer (6 Pcs)', price: 295 },
      { name: 'Paneer Zaffrani Tikka (6 Pcs)', price: 295 },
      { name: 'Bharwan Aloo (8 Pcs)', price: 295 },
      { name: 'Kalimirch Mushroom', price: 450 },
      { name: 'Assorted Veg Kebab Platter (20Pcs)', price: 999 },
    ],
  },
  starterNonVeg: {
    aireSignature: [
      { name: 'Chilly Fried Chicken (4Pcs)', price: 375 },
      { name: 'Szechwan Chicken (6 Pc)', price: 375 },
      { name: 'Murg Chandi Tikka (2 Pcs)', price: 375 },
      { name: 'Murgh Makhani Tikka (6 Pcs)', price: 375 },
      { name: 'Tangri Kebab (4Pcs)', price: 385 },
      { name: 'Dynamite Fish (6 Pcs)', price: 385 },
      { name: 'Tandoori Fish (6 Pcs)', price: 385 },
    ],
    pune: [{ name: 'Tandoori Jaboos (6 Pcs)', price: 400 }],
    kutne: [
      { name: 'Mutton Champ Kebab (6 Pcs)', price: 485 },
      { name: 'Mutton Seekh (4 Pcs)', price: 485 },
      { name: 'Non-Veg Kebab Platter (20 Pcs)', price: 1250 },
    ],
    chinese: [
      { name: 'Drums of Heaven (6 Pc)', price: 315 },
      { name: 'Chilli Honey Crispy Chicken (6 Pic)', price: 325 },
      { name: 'Let Me Kai Chicken (6 Pic)', price: 325 },
      { name: 'Chicken Spring Roll', price: 325 },
      { name: 'Chicken Lollipop (4 Pcs)', price: 340 },
      { name: 'Pan Fried Fish (6 Pc)', price: 345 },
      { name: 'Butter Garlic Fish (6 Pic)', price: 345 },
      { name: 'Chicken Wings (4 Pcs)', price: 345 },
      { name: 'Chilli Prawn (5 Pc)', price: 365 },
      { name: 'Lam-Mee- Van Prawn (5 Pic)', price: 365 },
    ],
    tandoori: [
      { name: 'Murgli Angara Kebab (6 Pic)', price: 325 },
      { name: 'Murgh Malai Kebab (6 Pcs)', price: 325 },
      { name: 'Murgh Malai Kebab', price: 325 },
      { name: 'Bhatti Da Murgh (Half / Full)', price: [290, 520] },
      { name: 'Murgh Reham Kebab (6 Pc)', price: 325 },
    ],
    continental: [
      { name: 'Fish Finger (6 Pc)', price: 385 },
      { name: 'Fish & Chips', price: 385 },
      { name: 'Prawn Cocktail (5 Pc)', price: 450 },
    ],
    fishNPrawn: [
      { name: 'Ajwaini Fish Tikka (6 Pc)', price: 345 },
      { name: 'Fish Tikka (6 Pcs)', price: 345 },
      { name: 'Tandoori Prawn (6 Pcs)', price: 365 },
    ],
    mutton: [
      { name: 'Mutton Seekh Kebab (6 Pc)', price: 475 },
      { name: 'Mutton Adrak Ke Panje (6 Pcs)', price: 475 },
    ],
    continental2: [
      { name: 'Chicken Nuggets', price: 375 },
      { name: 'B.B.Q Chicken Wings', price: 375 },
    ],
  },
  grilledAndBaked: {
    vegAndNonVeg: [
      { name: 'Cheese Corn Sandwich', price: 215 },
      { name: 'Tickle Pickle Sandwich', price: 225 },
      { name: 'Club Sandwich', price: 225 },
      { name: 'Chicken Jungle Sandwich', price: 350 },
      { name: 'Smokey Spicy Chicken Sandwich', price: 365 },
      { name: 'Chicker Fajita Sandwich', price: 375 },
    ],
    pizzas: [
      { name: 'Makhani Delight', price: 325 },
      { name: 'Cheese Overload', price: 325 },
      { name: 'Rum Ta Hell', price: 325 },
      { name: 'Greek Piezo', price: 335 },
      { name: 'Chicken Raid', price: 600 },
      { name: "Lovers Bite's", price: 600 },
      { name: 'Farmhouse Pizza', price: 350 },
    ],
  },
  momoAndBurgers: {
    vegAndNonVeg: [
      { name: 'Veg Steam Momo', price: 200 },
      { name: 'Crispy Fried Momo', price: 220 },
      { name: 'Pan Fried Momo in Schezwan Sauce', price: 235 },
      { name: 'Crunchy Veg Momo', price: 235 },
      { name: 'Chicken Steam Momo', price: 250 },
      { name: 'Chicken Fried Momo', price: 250 },
      { name: 'Pan Fried Chicken Momo', price: 275 },
      { name: 'Crunchy Chicken Momo', price: 275 },
    ],
    burgers: [
      { name: 'Veg Burger', price: 300 },
      { name: 'Chicken Burger', price: 350 },
    ],
  },
  houseOfPasta: {
    vegAndNonVeg: [
      { name: 'Alfredo', price: [300, 375] },
      { name: 'Arrabbiata', price: [300, 375] },
      { name: 'Aglio E Olio', price: [300, 375] },
      { name: 'Primavera', price: [300, 375] },
      { name: 'Napolitana', price: [310, 385] },
      { name: 'Mac & Cheese', price: [325, 400] },
      { name: 'Pink Sauce', price: [350, 420] },
      { name: 'Lasagne', price: [350, 420] },
    ],
  },
  mainCourseVeganNonVegan: {
    breadsFromATandoor: [
      { name: 'Roti', price: 65 },
      { name: 'Naan', price: 110 },
      { name: 'Lachha Paratha', price: 85 },
      { name: 'Kulcha', price: 130 },
    ],
    dalsAndCurry: [
      { name: 'Dal (Choice of Your Flavor)', price: 235 },
      { name: 'Vegetable (Choice of Flavor)', price: 250 },
      { name: 'Paneer (Choice of Your Flavor)', price: 350 },
      { name: 'Paneer (Choice of Your Sauces)', price: 375 },
      { name: 'Manchurian (Veg / Non-Veg)', price: [300, 400] },
    ],
    noodles: [
      { name: 'Chowmein Noodles', price: [250, 300, 350] },
      { name: 'Hakka Noodles', price: [250, 300, 350] },
      { name: 'Cantonese Noodles', price: [250, 300, 350] },
    ],
    chopsuey: [
      { name: 'Veg / Non-Veg Chopsuey', price: [300, 350] },
      { name: 'American Chopsuey', price: [300, 350] },
    ],
    riceAndBiryani: [
      { name: 'Basmati Rice', price: 200 },
      { name: 'Pulao (Choice of Your Flavor)', price: 300 },
      { name: 'Fried Rice', price: [250, 300, 350] },
      { name: 'Nasi Goreng Rice', price: [250, 300] },
    ],
  },
  mainCourseVegOrNonVeg: {
    chicken: [
      { name: 'Chicken (Choice of Your Sauce)', price: 385 },
      { name: 'Fish (Choice of Your Flavor)', price: 400 },
      { name: 'Fish (Choice of Your Sauce)', price: 400 },
      { name: 'Prawn (Choice of Your Flavor)', price: 450 },
      { name: 'Prawn (Choice of Your Sauce)', price: 450 },
      { name: 'Mutton (Choice of Your Flavor)', price: 485 },
    ],
    tandooriKaThawa: [
      { name: 'Tandoori Mushroom', price: 325 },
      { name: 'Signature Chicken Biryani', price: 375 },
      { name: 'Royal Mutton Biryani', price: 450 },
    ],
    salad: [
      { name: 'Garden Fresh Green Salad', price: 220 },
      { name: 'Greek Salad / Ceasor Salad', price: 300 },
      { name: 'Mixed Fruit Salad', price: 350 },
    ],
    accompaniment: [
      { name: 'Papad', price: 100 },
      { name: 'Raita', price: 150 },
    ],
  },
  aireSpecialComboAndSizzler: {
    combosVegAndNonVeg: [
      {
        name: 'Combo I - Biabcode Drinks+Crispy Chilli Baby Corn+Veg Hakka Noodles+Paneer Butter Masala+Garlic Naan+Gulab Jamun',
        price: 399,
      },
      {
        name: 'Combo I - Biabcode Drinks+Paneer Tikkss+Veg Fried Rice+ Chilli Paneer+Garlic Naan+Gulab Jamun',
        price: 399,
      },
      {
        name: 'Combo II - Biabcode Drinks+Murg Malai Kababs+ Kaju Kismis Chicken+Chicken Fried Rice+Naan+Gulab Jamun',
        price: 599,
      },
      {
        name: 'Combo IV - Biabcode Drinks+Crispy Fried Chicken+Chicken Chilli Garlic Noodles+Chilli Chicken+Burhan',
        price: 599,
      },
      {
        name: 'Combo V - Biabcode Drinks+Cheese Chilli Toast+Farmhouse Pizza+Reshmi Kabab+Mint Mojito',
        price: 599,
      },
      {
        name: 'Combo VI - Biabcode Drinks+French Fries+BBQ Pizza+Chicken Lasagne+Choice of Ice-cream',
        price: 799,
      },
    ],
    sizzler: [
      { name: 'Paneer Shoqunoff', price: 400 },
      { name: 'Vegetable Steak', price: 400 },
      { name: 'Chicken Shoqunoff', price: 500 },
      { name: 'Grilled Fish', price: 550 },
      { name: 'Crispied Chicken Sizzler (Rice/ Noodles)', price: 550 },
      { name: 'Chinese Fish Sizzler (Rice/ Noodle)', price: 550 },
      { name: 'Chinese Prawn Sizzler (Rice/ Noodle)', price: 600 },
    ],
  },
  desserts: [
    { name: 'Sizzling Brownie with Ice-Cream', price: 350 },
    { name: 'Brownie with Hot Chocolate Sauce', price: 300 },
    { name: 'Toffee Walnut with Ice-Cream', price: 220 },
    { name: 'Blueberry Cheese Cake', price: 450 },
    { name: 'Pan Cake', price: 280 },
    { name: 'Fried Hot Ice-Cream (2 Pcs)', price: 320 },
    { name: 'Fruit Salad', price: 350 },
    { name: 'Hot Gulab Jamun with Rabri (2 Pcs)', price: 285 },
    { name: 'Choice of Ice Cream (2 scoops)', price: 150 },
    { name: 'Color Ka Halua', price: 200 },
    { name: 'Fimi', price: 300 },
  ],
  hookah: {
    special: [
      { name: 'Lemon Rasna', price: [699, 799, 999] },
      { name: 'Aire Specail', price: [699, 799, 999] },
      { name: 'Aire Special', price: [699, 799, 999] },
      { name: 'Gum Speari', price: [699, 799, 999] },
      { name: 'Kiwi Spring Water', price: [699, 799, 999] },
      { name: 'Elaichi Mint', price: [699, 799, 999] },
      { name: 'Blueberry Spring Water', price: [699, 799, 999] },
      { name: 'Brain Freezer Orange', price: [699, 799, 999] },
      { name: 'Teen Paan', price: [699, 799, 999] },
      { name: 'Vanilla Rasna', price: [699, 799, 999] },
      { name: 'Orange Rasna', price: [699, 799, 999] },
      { name: 'Teen Paan Rasna', price: [699, 799, 999] },
      { name: 'Gum Mint', price: [699, 799, 999] },
      { name: 'Elaichi Mint', price: [699, 799, 999] },
      { name: 'Sex On the Beach', price: [699, 799, 999] },
      { name: 'Mango', price: [699, 799, 999] },
      { name: 'Watermelon Blast', price: [699, 799, 999] },
      { name: 'Cappuccino', price: [699, 799, 999] },
      { name: 'Witch Candy', price: [699, 799, 999] },
      { name: 'High 5', price: [699, 799, 999] },
      { name: '4 Am', price: [699, 799, 999] },
      { name: 'Hustle Bustle', price: [699, 799, 999] },
      { name: 'Pan Zombie', price: [699, 799, 999] },
      { name: 'Pan Razzmatazz', price: [699, 799, 999] },
      { name: 'Daft Rose', price: [699, 799, 999] },
      { name: 'Teen Pan Peach', price: [699, 799, 999] },
      { name: 'Commissionare', price: [699, 799, 999] },
      { name: 'Green Apple', price: [699, 799, 999] },
      { name: 'Strawberry', price: [699, 799, 999] },
      { name: 'Magical Paan', price: [699, 799, 999] },
    ],
  },
  refreshingBeverage: {
    fruitJuiceBase: [
      { name: 'Red Lime', price: 140 },
      { name: 'Blue Berry', price: 150 },
      { name: 'Out of Ground', price: 170 },
      { name: 'Gut Biter', price: 200 },
      { name: 'Green Draco', price: 220 },
      { name: 'Blue Hawaiian', price: 265 },
    ],
    iceCreamBase: [
      { name: 'Mango Mastani', price: 200 },
      { name: 'Orange Blastania', price: 200 },
      { name: 'Chocolate Colada', price: 200 },
      { name: 'Kivi Berry Juice', price: 220 },
      { name: 'Family Combination Magic', price: 220 },
    ],
    sodaBase: [
      { name: 'Peach Lime Soda', price: 140 },
      { name: 'Tomato Kathputli', price: 140 },
      { name: 'Chocolate Iced Coffee', price: 180 },
      { name: 'Saltwator Fresh Mint', price: 180 },
      { name: 'Fresh Norriday', price: 200 },
    ],
    classicMojito: [
      { name: 'Mojito Master', price: 200 },
      { name: 'Kivi Green Mojito', price: 200 },
      { name: 'Green Apple Mojito', price: 200 },
      { name: 'Strawberry Mojito', price: 200 },
      { name: 'Watermelon Mojito', price: 200 },
    ],
    signatureMojito: [
      { name: 'Pappermint Mojito', price: 200 },
      { name: 'Blueberries (Hi-Me)', price: 200 },
      { name: 'Rose Sensation', price: 200 },
      { name: 'Red Bull Mojito', price: 200 },
    ],
    aireSpecial: [
      { name: 'Huskey Water', price: 200 },
      { name: 'Sunset Drafting', price: 200 },
      { name: 'Double Trouble', price: 200 },
      { name: 'Ninja Berry', price: 200 },
      { name: 'Bright Elements', price: 200 },
      { name: 'Blue Cherry', price: 200 },
    ],
    shakes: [
      { name: 'Chocolate Milk Shake/ Oreos Milk', price: 300 },
      { name: 'Browne with Added Joy Added', price: 300 },
      { name: 'Strawberry Milk Shake', price: 300 },
      { name: 'Dry Fruits Milkshake', price: 300 },
      { name: 'Biscoff Shake', price: 300 },
      { name: 'Mango Shake', price: 300 },
    ],
    smoothie: [
      { name: 'Tropical Power Shake', price: 200 },
      { name: 'Pineapple with Honey', price: 200 },
      { name: 'Strawberry Feel', price: 200 },
      { name: 'Orange Juice Ginger', price: 200 },
      { name: 'Papaya with Ginger', price: 200 },
      { name: 'Carrot In The Fly', price: 200 },
      { name: 'June Favorite', price: 200 },
    ],
  },
};

export default { awards, aireMenuData };
